import React from 'react'
import PropTypes from 'prop-types'
import FilterPill from './FilterPill'

const FilterPillsSection = props => {
  let filters = []
  let idx = 0
  for (const label in props.filterOptions) {
    const option = props.filterOptions[label]
    let filterPill = (
      <FilterPill
        label={label}
        filterValue={option.filterValue}
        handleClick={filterValue => {
          option.onClickPill(filterValue)
        }}
        active={option.active}
        key={idx}
      />
    )
    filters.push(filterPill)
    idx++
  }

  return (
    <div className='FilterPillsSection' style={{ textAlign: 'left' }}>
      {filters}
    </div>
  )
}

FilterPillsSection.defaultProps = {
  filterOptions: {}
}

FilterPillsSection.propTypes = {
  filterOptions: PropTypes.object
}

export default FilterPillsSection
